import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      maxWidth: "336px",
      margin: "0 auto",
      color: "ink",
      "& h2": {
        textAlign: "center",
        marginBottom: "baseUnit.mobile2",
        desktop: {
          marginBottom: "baseUnit.mobile3",
        },
      },
      desktop: {
        maxWidth: "718px",
      },
    }),
  itemsContainer: () =>
    css({
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "6px",
      desktop: {
        gap: "baseUnit.mobile3",
      },
    }),
};
